
/*eslint-disable*/
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

import {
tradingTypeOptions,
resetTextBylangKey,
dateSelectedOptions,
} from "../../../libs/options.js";
import noData from "@/common/components/noData/index.vue";
import loadMore from "@/common/components/load-more/index.vue";
import { parseTime, toTimestamp } from "@/common/utils/Date.js";

export default {
directives: {
TransferDom,
},
filters: {
timeFilter(time) {
return parseTime(time);
},
},
components: {
XButton,
XInput,
Group,
Flexbox,
FlexboxItem,
TransferDom,
Popup,
InlineLoading,
noData,
loadMore,
},
data() {
return {
total: null, // 无账单
searchShow: false,





searchParams: {
days: "90",
payType: 0,
},
balanceList: [],
step: 10,
pageSize: 10,
pageNo: 1,
finish: null,
};
},
computed: {
selectionTimeOptions() {
return resetTextBylangKey(
dateSelectedOptions,
this.$t("mine").timeOptions
);
},
selectionType() {
return resetTextBylangKey(
tradingTypeOptions,
this.$t("mine").tradingRecord.tradingTypeOptions
);
},
},
created() {
this.getBalanceList(); 
},
methods: {
handShowSearch(data) {

this.searchShow = data;
},

goDetail(item) {

this.$router.push({
path: "/My/merch-record/merchDetail",
query: { id: item.assetsBalanceLogId, payType: item.payType },
});
},

_conditionSelected(str, val) {

this.searchParams[str] = val;
},

_Search() {

this.balanceList = [];
this.pageSize = this.step - 0;
this.searchShow = false;
this.$store.commit("updateLoadingStatus", { isLoading: true });
if (this.$refs.loadMoreEle) this.$refs.loadMoreEle.scrollToTop();
this.getBalanceList();
},

_refresh({ finish }) {

this.finish = finish;
this.pageSize = this.step - 0;
this.getBalanceList();
},

_loadmore({ finish }) {

this.finish = finish;
if (this.pageSize * this.pageNo >= this.total) {
this.$vux.toast.show({
text: this.$t("others").noData1,
type: "cancel",
});
this.finish();
return;
}
this.pageSize += this.step;
this.getBalanceList();
},

getBalanceList(type) {

this.$api.post(
this.$urls.VIP.myBalanceList,
this.getParams(),
(resp) => {
const { data, code } = resp.data;
if (code === 200) {
this.total = data.total;
this.balanceList = data.list.sort(
(a, b) =>
new Date(b.month).valueOf() - new Date(a.month).valueOf()
);
}
if (this.finish) this.finish();
this.$store.commit("updateLoadingStatus", { isLoading: false });
},
(err) => {
this.$store.commit("updateLoadingStatus", { isLoading: false });
}
);
},

getParams() {

const nowTime = new Date().getTime();
const endTime = toTimestamp(nowTime);
const startTime = toTimestamp(
nowTime - 1000 * 60 * 60 * 24 * this.searchParams.days
);
return {
UUID: this.$store.state.UUID,
startTime,
endTime,
payType: this.searchParams.payType,
pageNo: this.pageNo,
pageSize: this.pageSize,
};
},

filterTradingType(val) {
if (val === "0") val = "100";
return this.$t("mine").tradingRecord.tradingTypeOptions[val];
},
},
destroyed() {},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/MerchRecord/merchRecord.vue